import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css';
import { useFormik } from 'formik';

import * as Yup from 'yup';


const validationSchema = Yup.object({
	email: Yup.string().email('Invalid email address').required('Email is required'),
	password: Yup.string().min(6, 'Password must be at least 6 characters').required('Password is required')
})

export default function Login() {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		if (!email || !password) {
			setError('Please enter email and password');
			return;
		}   


		
		
		setLoading(true);
		try {
			const res = await fetch('https://backend.zenithcbe.com/login', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email, password }),
			});

			if (res.ok) {
				const data = await res.json().catch(() => ({}));
				// store token if returned: localStorage.setItem('token', data.token)
				navigate('/home');
				return;
			}

			if (res.status === 401) {
				setError('Invalid email or password');
			} else {
				const body = await res.json().catch(() => ({}));
				setError(body.error || 'Login failed');
			}
		} catch (err) {
			setError('Network error: ' + (err.message || err));
		} finally {
			setLoading(false);
		}
	};
		const formik = useFormik({
		initialValues: {
			email: '',
			password: ''
		
		},
	validationSchema: validationSchema,

	onsubmit: (values) => {
		setEmail(values.email);
		setPassword(values.password);
		handleSubmit();
		}

	});


	return (
	
		<div className="login-page">
			<form className="login-form" onSubmit={handleSubmit}>
				<h2>Sign In</h2>
				{error && <div className="login-error">{error}</div>}

				<div className="login-field"><label htmlFor="email">Email</label>
				<input
					id="email"
					type="email"
					value={formik.values.email}
					onBlur={formik.handleBlur}
					onChange={formik.handleChange}
					placeholder="you@example.com"
					required
				/> 
				{formik.touched.email && formik.errors.email ? (
					<div className="form-error">{formik.errors.email}</div>
				) : null}
				
				</div>
				<div>
				<label htmlFor="password">Password</label>
				<input
					id="password"
					type="password"
					value={formik.values.password}
					onBlur={formik.handleBlur}
					onChange={formik.handleChange}
					placeholder="Your password"
					required
				/>
				{formik.touched.password && formik.errors.password ? (
					<div className="form-error">{formik.errors.password}</div>
				) : null}
				
				</div>
				

				<button type="submit" className="login-btn" disabled={loading}>
					{loading ? 'Signing in...' : 'Sign In'}
				</button>

			</form>
		</div>
	);
}
